import React, { useEffect, useState, useContext } from 'react'
import { ExecutionDataset } from '../components/ExecutionDataset'
import { HeaderContainer } from '../components/HeaderContainer'
import { TableData } from '../components/TableData'
import i18n from 'live/services/i18n'
import { StyledOverlay } from '../styles/styles'
import { LoadingSpinner } from 'plugin-wells/shared/components/LoadingSpinner'
import { DvDDataContext } from '../context/DvDDataContext'

interface Props {
    selected: {
        asset: {
            id: string
            name: string
        }
    }
}

export const DvDTabContent = ({ selected, ...props }: Props) => {
    const [triggerRefresh, setTriggerRefresh] = useState<boolean>(false)
    const { heightOfCentralComponents, loadingDataset, isSyncForced, showReprocessModal } = useContext(DvDDataContext)
    const datasetType = 'ds_day_depth'
    const { id, name } = selected?.asset

    return (
        <div className="flex-column">
            <HeaderContainer
                selected={selected}
                title={i18n('Days vs Depth Execution Data')}
                subtitle={''}
                about={i18n(
                    'This is where you can manage the real-time data on drilling depth compared to the number of days spent drilling'
                )}
                addCollapse={false}
                datasetType={datasetType}
            >
                <StyledOverlay>
                    {(loadingDataset || isSyncForced) && !showReprocessModal && (
                        <StyledOverlay className="inner" style={{ height: heightOfCentralComponents }}>
                            <LoadingSpinner message="Loading..." />
                        </StyledOverlay>
                    )}
                    <TableData selected={selected} datasetType={datasetType}></TableData>
                </StyledOverlay>

                {/* <MemoizedTableData></MemoizedTableData> */}
            </HeaderContainer>
        </div>
    )
}
